import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import { useGroupFilters } from '@app/group/hooks/use-group-filters';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetGroupCollections } from '@shared/api/hooks/group/collections';
import { GroupCollectionsListSortItem } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';
import GroupPage from '../components/group-page';
import GroupCollectionsTable from '../components/tables/group-collections-table';

export default function GroupCollectionsPage() {
  const { page, perPage, sort } = useDataTableQueryState();
  const [name] = useQueryState('name', parseAsString);
  const [{ orgs }] = useGroupFilters();

  const data = useGetGroupCollections({
    page,
    page_size: perPage,
    sort: formatMultipleSortingForEndpoint(
      sort ?? []
    ) as GroupCollectionsListSortItem[],
    organizations: orgs.length ? orgs : undefined,
    search: name || undefined,
  });

  const count = data.data?.count ?? 0;
  const pageCount = Math.ceil(count / (perPage || 10));

  if (data.isError) throw new Error('Failed to load group collections');

  return (
    <GroupPage pageKey="productsCollections">
      <GroupCollectionsTable {...data} pageCount={pageCount} />
    </GroupPage>
  );
}
